import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { withRouter } from 'next/router'
import { VehiclePartsPagination } from '../src/modules/ads/pagination/components'
import { GroupsListWithNewParts } from 'SRC/modules/groups/components'
import { GroupsMenuMobile } from 'SRC/modules/categories/components'
import { fetchVehicleParts, setError } from 'SRC/modules/vehicleParts/list/actions'
import { List as PartsList, BottomNavigation } from 'SRC/modules/vehicleParts/list/components'
import { Sidebar as VehiclePartSidebar } from 'SRC/modules/vehicleParts/detail/components'
import withTranslation from 'next-translate/withTranslation'
import { VehiclPartsFilterGume } from 'SRC/modules/vehicleParts/filter'
import { fetchFilteredFields } from 'SRC/modules/vehicleParts/filter/actions'
import { Page, Page404 } from '../src/ui'
import initialState from '../src/modules/redux/initialState'
import { fetchInfo, setInfo } from '../src/modules/users/detail/actions'
import { deepCopy } from '../src/utils'
import config from '../src/config/config.json'

import translations from '../public/data/translations.json'

class VehiclPartsPage extends React.Component {
	componentDidMount() {
		setTimeout(() => {
			window.scrollTo(0, 0)
		}, 200)
	}

	componentDidUpdate(prevProps) {
		if (prevProps?.router?.asPath !== this.props?.router?.asPath) {
			setTimeout(() => {
				window.scrollTo(0, 0)
			}, 200)
		}
	}

	static async getInitialProps(ctx) {
		const { store, query } = ctx

		const locale = ctx?.locale?.toUpperCase() || query?.locale?.toUpperCase() || 'ME'

		const isMobileDevice = store.getState().common.isMobileDevice

		const userRequestParams = { username: 'YN483', locale }
		await store.dispatch(fetchInfo(userRequestParams))

		let isPageExists = true

		await store.dispatch(fetchFilteredFields({ group: 'gume', payload: { locale } }))

		const requestParams = {
			page: Number(query?.page || 1),
			limit: 36,
			group: 'gume',
			locale,
		}

		await store.dispatch(fetchVehicleParts(requestParams))

		return {
			title: isPageExists
				? `${translations.noviDjeloviTitle[locale]}`
				: config.pages.notFoundTitle,
			isPageExists,
			isMobileDevice,
			state: VehiclPartsPage.getPageState(store, isPageExists)
		}
	}

	static getPageState(store, isPageExists = false) {
		const state = deepCopy(initialState)
		if (store) {
			const currentState = store.getState()

			state.user.auth.isAuthorized = currentState.user.auth.isAuthorized
			state.user.profile.error = currentState.user.profile.error
			state.user.profile.info = currentState.user.profile.info
			state.user.profile.favouriteAds = currentState.user.profile.favouriteAds
			state.user.profile.savedFilters = currentState.user.profile.savedFilters
			state.user.profile.favouriteProfiles = currentState.user.profile.favouriteProfiles
			state.user.profile.packageInactiveMessage = currentState.user.profile.packageInactiveMessage
			state.user.profile.priceTypes = currentState.user.profile.priceTypes
			state.user.listSidebar = currentState.user.listSidebar
			state.user.detail.info = currentState.user.detail.info

			state.common.transitions = currentState.common.transitions
			state.common.router = currentState.common.router
			state.common.is404 = !isPageExists
			state.common.isMobileDevice = currentState.common.isMobileDevice
			state.common.userTypes = currentState.common.userTypes
			state.common.pageMetaTags = currentState.common.pageMetaTags
			state.common.pageMetaTagsSingle = currentState.common.pageMetaTagsSingle

			state.groups.elements = currentState.groups.elements

			state.categories.currentSubcategory = currentState.categories.currentSubcategory

			if (isPageExists) {
				state.vehicleParts.list = currentState.vehicleParts.list
				state.vehicleParts.filter = currentState.vehicleParts.filter
			}

			state.geoObjects.countries = currentState.geoObjects.countries
			state.geoObjects.regions = currentState.geoObjects.regions
			state.geoObjects.cities = currentState.geoObjects.cities

			state.form = currentState.form
		}
		return state
	}

	render() {
		const {
			isPageExists,
			isMobileDevice,
			i18n: { t }
		} = this.props

		const noAdsMessage = t('common:vehicle_parts_no_products_available')

		return isPageExists ? (
			<Page className='main-content main-content-full'>
				<div className='vehicle-parts-content'>
					<div className='vehicle-parts-content-main'>
						{!isMobileDevice ? <GroupsListWithNewParts /> : (
							<>
								<GroupsMenuMobile
									filtersCount={0}
									vehiclePartsGroup={'gume'}
									vehiclePartsCategory={''}
									vehiclePartsFilterValues={{}}
								/>
							</>
						)}

						<VehiclPartsFilterGume filterValues={{}} />

						<PartsList noAdsMessage={noAdsMessage} />
						<VehiclePartsPagination />

						{isMobileDevice ? <BottomNavigation filtersCount={0} /> : null}
					</div>
					<VehiclePartSidebar />
				</div>
			</Page>
		) : <Page404 />
	}
}

VehiclPartsPage.propTypes = {
	isPageExists: PropTypes.bool.isRequired,
	group: PropTypes.string.isRequired,
}

VehiclPartsPage.defaultProps = {
	isPageExists: false
}

const enhance = compose(
	withRouter,
	withTranslation
)

export default enhance(VehiclPartsPage)